<template>
  <form @submit.prevent="signalAdd" class="form-add-signals">
      <DxForm :form-data="newSignalData"  label-location="left" :min-col-width="350">
        <DxGroupItem :col-count="2" :min-col-width="330">
          <DxSimpleItem data-field="assetName" :editor-options="{ disabled: true }" />
          <DxSimpleItem data-field="name" 
            editor-type="dxTextBox"
            :editor-options="{ maxLength: 50 }" >
            <DxRequiredRule message="Name is required" />
            <DxPatternRule pattern="^[a-zA-Z\s0-9_/:]*$" message="The Name can only contain numbers and letters or '_ / :'" />
          </DxSimpleItem>
          <DxSimpleItem data-field="signalType" 
            editor-type="dxSelectBox"
            :editor-options="{ items: signalTypeList }" >
            <DxRequiredRule message="A signal type is required" />
          </DxSimpleItem>
          <DxGroupItem :col-count="2" :min-col-width="330" vertical-aligment="center">
            <DxSimpleItem data-field="isIoT" editor-type="dxCheckBox" />
            <DxSimpleItem data-field="isKpi" editor-type="dxCheckBox" />
          </DxGroupItem>
        </DxGroupItem>
        <DxSimpleItem>    
          <template #default>
            <DxDataGrid
              :data-source="SSPointsDS"
              :selection="{ mode: 'single' }"
              :show-borders="true"
              :hover-state-enabled="true"
              :allow-column-resizing="true"
              key-expr="id"
              height="330"
              v-on:cell-Click="cellSelectionChange"
              >
               <DxSearchPanel
                  :visible="true"
                  :width="240"
                  placeholder="Search..."
                />
                <DxSelection mode="single" />
                <DxPaging :page-size="5"/>
                <DxColumn data-field="ss_id"/>
                <DxColumn data-field="label"/>
                <DxColumn data-field="name"/>
                <!--<DxColumn data-field="modBusAddrOffset"/>-->
                <DxColumn data-field="units"/>
                <!--<DxColumn data-field="type"/>
                <DxColumn data-field="size"/>-->
                <DxColumn data-field="static"/>
                <DxColumn data-field="sectionName"/>
                <DxColumn data-field="rwAccess"/>
                <DxColumn data-field="mandatory"/>
                <DxColumn data-field="description"/>
                <DxColumn data-field="comments"/>
                <DxToolbar>
                  <DxItem
                    location="before"
                    template="hintTemplate"
                  />
                  <DxItem
                    name="searchPanel"
                  />
                </DxToolbar>
                <template #hintTemplate>
                  <span>*</span>
                </template>
            </DxDataGrid>
          </template>
        </DxSimpleItem>
        <DxButtonItem :button-options="{ type:'success', width: '100%', text: 'create new signal', useSubmitBehavior: true }" />
      </DxForm>      
    </form>
</template>

<script>
import DxForm, {
  DxGroupItem,
  DxButtonItem,
  DxSimpleItem,
  DxRequiredRule,
  DxPatternRule,
} from 'devextreme-vue/form';
import {
  DxDataGrid,
  DxSelection,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxToolbar,
  DxItem,
} from 'devextreme-vue/data-grid';

import notify from 'devextreme/ui/notify';
import DataService from '../services/DataServiceTemplate';
import RawDataService from '../services/RawDataServiceTemplate';
import { ref, reactive } from 'vue';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";

export default {
  components: {
    DxForm,
    DxGroupItem,
    DxButtonItem,
    DxSimpleItem,
    DxRequiredRule,
    DxPatternRule,
   
    DxDataGrid,
    DxSelection,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxToolbar,
    DxItem,
  },
  props:{
    assetUuid:{
      type: String,
      default: "" 
    },
    assetName:{
      type: String,
      default: "" 
    },
  },
  
  watch:{
    assetName(){
      this.SSPointsDS.reload();
    }
  },
  emits: ['signal-update', 'cancel'],
  setup(props, { emit }) {
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const signalDataService = new DataService('masters/signals', 'signalId');
    const enfyoPointsService = new RawDataService('/sunSpec/config/enfyoPoints');
    const signalTypeDataService = new RawDataService('statics/tables/signalTypes');
    const signalTypeList = ref([]); 
    const newSignalData = reactive({
      name: '',
      units:'',
      label:'',
      desc:'',
      enfyoPoint_id:0,
      assetName: ' ',
      signalType: 'state',
      isIoT: false,
      isKpi: false,
      value: null,
      type: null,
      count: null,
      size:null,
      scaleFactor: null,
      rwAccess: null,
      mandatory: null,
      description: null,
      symbols: null,
      comments: null,
      static: null,
    });

    
    const SSPointsStore = new CustomStore({
      key: 'id',
      load: async() => {
        try{
          let newDs = [];
          const SSPointsService = new RawDataService('sunSpec/config/SSPoints/'+props.assetUuid);
          const pointList = await SSPointsService.getAll();
          const pointListF= pointList.filter((p)=>p.enfyoSignal_id=='1' & p.modBusAddrOffset>1 & !p.name.includes('_SF'))
          
          for(const point of pointListF){
            newDs.push(point)    
          }
          return newDs;
        }catch(err) { notify('error building assets tree: '+err.message, 'error', 4000); }
      }
    });

    const SSPointsDS = new DataSource({
      store: SSPointsStore,
      paginate: false
    });

    const signalAdd = async() => {
      try{
        if (newSignalData.name){
          const rawList = await signalDataService.dataStore.load();
          const signalExists = rawList.data?.find?.(sg => sg.name == newSignalData.name);
          
          if (signalExists?.singalId){
            return notify("The signal name already exists for this asset", "error", 4500);
          }
          const dataObj = await signalDataService.dataStore.insert(newSignalData);
          if(dataObj.isOk ){
            if (newSignalData.enfyoPoint_id!=0){
              const dataObj2 = await enfyoPointsService.update(newSignalData.enfyoPoint_id,{
                enfyoSignal_id:dataObj.data.insertId
              })
              
              if(dataObj2.affectedRows==1){
                notify(dataObj.data.messsage, "success", 3500);
              }
            }else{
              notify(dataObj.data.messsage, "success", 3500);
            }
            emit('signal-update', { 
                  objectType: 'signal', 
                  key: dataObj.data.insertId, 
                  type:'insert', 
                  data: { 
                    signalId: dataObj.data?.insertId, 
                    assetName: newSignalData.assetName,
                    signalName: newSignalData.name,
                    description: '---'+newSignalData.name+'---' },
                  message: dataObj.data.messsage||'signal inserted to asset' });
            
          }

          newSignalData.name = '';
          newSignalData.signalType =  'state';
          newSignalData.enfyoPoint_id = 0; 
          
          SSPointsDS.reload();
        }
      }
      catch(error){ stErrorCb(error); }
    }

    
    const cellSelectionChange = (e)=>{
      newSignalData.enfyoPoint_id=e.data.id;
      newSignalData.units = e.data.units;
      newSignalData.label = e.data.label;
      newSignalData.description = e.data.description;
      newSignalData.rwAccess = e.data.rwAccess;
      newSignalData.value = e.data.value;
      newSignalData.type = e.data.type;
      newSignalData.count = e.data.count;
      newSignalData.size = e.data.size;
      newSignalData.scaleFactor = e.data.scaleFactor;
      newSignalData.mandatory = e.data.mandatory;
      newSignalData.symbols = e.data.symbols;
      newSignalData.comments = e.data.comments;
      newSignalData.static = e.data.static;

    }

    signalTypeDataService.getAll().then(sigList =>{
      const typeList = sigList.map(sTypeObj => sTypeObj.id);
      signalTypeList.value = typeList;
    }).catch(stErrorCb);

    const loadForm = ()=>{
      newSignalData.assetName = props.assetName;
    }
    loadForm();

    return {
      newSignalData,
      signalTypeList,
      SSPointsDS,
      signalAdd,
      cellSelectionChange      
    }
  }
}
</script>

<style>
.form-add-signals .dx-item .dx-box-item {
    height: 40px; /* Ajusta el tamaño a tu preferencia */
    
    
}
.form-add-signals .dx-field-item:not(.dx-field-item-has-group):not(.dx-field-item-has-tabs):not(.dx-first-row):not(.dx-label-v-align) {
    padding-top: 10px;
}
</style>